<section class="unauthorized">
  <h2>You are not authorized to access this area.</h2>
</section>
